export enum CAType {
  All = 'All',
  Server = 'Server',
  Workstation = 'Workstations',
}
